import PopUpConfigInfoDialog from './popUpConfigInfoDialog';
export default PopUpConfigInfoDialog;